<template>
  <v-card data-qa="rolepermissionedit-card-aswm8o">
    <v-card-title class="role-card-title" data-qa="rolepermissionedit-card-title-wosfw">
      <span data-qa="rolepermissionedit-span-f908p3">{{ $t('roleMaintenance.rolePermissions') }}</span>
      <v-spacer />
      <v-btn v-if="!expanded" icon @click="expandAll" data-qa="rolepermissionedit-btn-ja9ruq">
        <v-tooltip top :color="primaryColor" data-qa="rolepermissionedit-tooltip-xnlpaq">
          <template v-slot:activator="{ on, attrs }">
            <v-icon large :color="primaryColor" v-bind="attrs" v-on="on" data-qa="rolepermissionedit-icon-ii18jm">mdi-expand-all-outline</v-icon>
          </template>
          <span data-qa="rolepermissionedit-span-3tz9d">Expand all</span>
        </v-tooltip>
      </v-btn>
      <v-btn v-else icon @click="collapseAll" data-qa="rolepermissionedit-btn-wu0poe">
        <v-tooltip top :color="primaryColor" data-qa="rolepermissionedit-tooltip-ttz0r">
          <template v-slot:activator="{ on, attrs }">
            <v-icon large :color="primaryColor" v-bind="attrs" v-on="on" data-qa="rolepermissionedit-icon-acx23d">mdi-collapse-all-outline</v-icon>
          </template>
          <span data-qa="rolepermissionedit-span-i3rklp">Collapse all</span>
        </v-tooltip>
      </v-btn>
    </v-card-title>
    <v-card-text data-qa="rolepermissionedit-card-text-a99nui">
      <v-expansion-panels v-model="panels" multiple data-qa="rolepermissionedit-expansion-panels-fv8ril">
        <v-expansion-panel
          v-for="(group, index) in groupedPerCategory"
          :key="index"
         :data-qa="`rolepermissionedit-expansion-panel-hvxxld-${index}`">
          <v-expansion-panel-header data-qa="rolepermissionedit-expansion-panel-header-78z7a4">{{ group.category }}</v-expansion-panel-header>
          <v-expansion-panel-content data-qa="rolepermissionedit-expansion-panel-content-kt0eia">
            <v-list data-qa="rolepermissionedit-list-a1y0rb">
              <v-list-item v-for="(item, idx) in group.items" :key="idx" :data-qa="`rolepermissionedit-list-item-v7t7hq-${idx}`">
                <v-list-item-content data-qa="rolepermissionedit-list-item-content-hxv0qh">
                  <v-list-item-title class="role-wrap-text" data-qa="rolepermissionedit-list-item-title-px01wb">{{ item.permissionName }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action data-qa="rolepermissionedit-list-item-action-1vvvug">
                  <v-switch
                    inset
                    dense
                    v-model="item.enabled"
                    :color="primaryColor"
                    data-qa="rolepermissionedit-switch-jjaidn"
                    @change="checkIsDirty(item)"
                  />
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-text>
  </v-card>
</template>

<script>
import '@/styles/pages/roles/roles.scss'

export default {
  name: 'RolePermissionEdit',
  props: {
    value: {
      type: Array,
      require: true
    }
  },
  data () {
    return {
      panels: [],
      expanded: false,
      mapPermissions: null
    }
  },
  mounted () {
    this.expandAll()
  },
  methods: {
    expandAll () {
      this.panels = this.groupedPerCategory.map((_, i) => i)
      this.expanded = true
    },
    collapseAll () {
      this.panels = []
      this.expanded = false
    },
    checkIsDirty (item) {
      item.assignedFlag = item.enabled ? 'Y' : 'N'
      const hasChanges = this.permissions
        .some(permission => {
          const originalPermission = this.mapPermissions.get(permission.permissionId)
          return permission.assignedFlag !== originalPermission?.assignedFlag
        })
      this.$emit('update:isDirty', hasChanges)
    }
  },
  computed: {
    permissions: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('input', newValue)
      }
    },
    groupedPerCategory () {
      if (!this.permissions.length) return []

      const groups = this.permissions.reduce((acc, item) => {
        const group = acc.find(g => g.category === item.permCategoryName)
        if (group) {
          group.items.push(item)
        } else {
          acc.push({ category: item.permCategoryName, items: [item] })
        }
        return acc
      }, [])
      return groups
    }
  },
  created () {
    this.mapPermissions = new Map()
    this.permissions.forEach(permission => {
      this.mapPermissions.set(permission.permissionId, {
        permissionName: permission.permissionName,
        assignedFlag: permission.assignedFlag
      })
    })
  }
}
</script>
